module.exports = __webpack_public_path__ + "img/saleImg.4e392dc0.svg";